'use client';
import { useMemo } from 'react';

import { ChatReview } from '~features/chatReview';
import { useModal } from '~hooks/useModal';

import { ChatReviewModalContext } from './index';

type Props = {
	children: React.ReactNode;
};

export const ChatReviewModalContextProvider = ({ children }: Props) => {
	const {
		isOpen: isReviewModalOpen,
		open: openReviewModal,
		close: closeReviewModal,
	} = useModal();

	const context = useMemo(() => {
		return {
			openReviewModal,
		};
	}, [openReviewModal]);

	return (
		<ChatReviewModalContext.Provider value={context}>
			{children}

			<ChatReview open={isReviewModalOpen} onClose={closeReviewModal} />
		</ChatReviewModalContext.Provider>
	);
};
